import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import { Button, Select, Checkbox } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { sortsDatas } from "../Datas";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { toast } from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import { BaseUrl } from "../../BaseUrl";
import axios from "axios";

function AddDoctorModal({ closeModal, isOpen, doctor, datas }) {
  // Title options - only Dr. and Nurse
  const titleOptions = [
    { id: 1, name: "Dr." },
    { id: 2, name: "Nurse" },
  ];

  const [title, setTitle] = useState(
    datas?.title
      ? titleOptions.find((t) => t.name === datas.title) || titleOptions[0]
      : titleOptions[0]
  );
  const [gender, setGender] = useState(
    datas?.gender
      ? sortsDatas.genderFilter.find((g) => g.name === datas.gender) ||
        sortsDatas.genderFilter[0]
      : sortsDatas.genderFilter[0]
  );
  const [category, setCategory] = useState(
    datas?.category
      ? { id: 1, name: datas.category }
      : { id: 1, name: "Select" }
  );
  const [subCategory, setSubCategory] = useState(
    datas?.subCategory
      ? { id: 1, name: datas.subCategory, code: datas.subCategoryCode }
      : { id: 1, name: "Select", code: null }
  );
  const [specialization, setSpecialization] = useState(
    datas?.specialization
      ? { id: 1, name: datas.specialization }
      : { id: 1, name: "Select" }
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [subscriptionAgreed, setSubscriptionAgreed] = useState(false);

  // Category options
  const categoryOptions = [
    { id: 1, name: "Select" },
    { id: 2, name: "Doctor" },
    { id: 3, name: "Nurse" },
  ];

  // Sub Category options - from registration screen
  // REMINDER HERE TO CREATE THIS VALUES IN A SEPERATE FILE AND IMPORT IT FROM THERE THIS IS NOT GOOD PRACTICE 
  const hardcodedDoctorSubcategories = [
    { subCategory: "Modern Medicine", code: 1 },
    { subCategory: "Dentist", code: 2 },
    { subCategory: "Homoeopathy", code: 3 },
    { subCategory: "Ayurveda", code: 4 },
    { subCategory: "Unani", code: 5 },
    { subCategory: "Siddha", code: 6 },
    { subCategory: "Sowa-Rigpa", code: 7 },
    { subCategory: "Nutrician", code: 8 },
    { subCategory: "Dietician", code: 9 },
  ];

  const hardcodedNurseSubcategories = [
    { subCategory: "RANM", code: 8 },
    { subCategory: "RN", code: 9 },
    { subCategory: "RN & RM", code: 10 },
    { subCategory: "RLHV", code: 11 },
  ];

  const getSubCategoryOptions = () => {
    if (category.name === "Doctor") {
      return [
        { id: 1, name: "Select", code: null },
        ...hardcodedDoctorSubcategories.map((item, index) => ({
          id: index + 2,
          name: item.subCategory,
          code: item.code,
        })),
      ];
    }
    if (category.name === "Nurse") {
      return [
        { id: 1, name: "Select", code: null },
        ...hardcodedNurseSubcategories.map((item, index) => ({
          id: index + 2,
          name: item.subCategory,
          code: item.code,
        })),
      ];
    }
    return [{ id: 1, name: "Select", code: null }];
  };

  // Specializations mapping - from registration screen
  const specializations = {
    "Modern Medicine#1": [
      { specialization: "Cardiologist", code: "CAR" },
      { specialization: "Neurologist", code: "NEU" },
      { specialization: "Orthopaedic Surgeon", code: "ORT" },
      { specialization: "Gastroenterologist", code: "GAS" },
      { specialization: "Dermatologist", code: "DER" },
      { specialization: "Pediatrician", code: "PED" },
      { specialization: "Radiologist", code: "RAD" },
      { specialization: "Psychiatrist", code: "PSY" },
      { specialization: "Endocrinologist", code: "END" },
      { specialization: "Pulmonologist", code: "PUL" },
      { specialization: "Nephrologist", code: "NEP" },
      { specialization: "Oncologist", code: "ONC" },
      { specialization: "ENT Specialist", code: "ENT" },
      { specialization: "Ophthalmologist", code: "OPH" },
      { specialization: "Urologist", code: "URO" },
      { specialization: "General Surgeon", code: "GSU" },
      { specialization: "Plastic Surgeon", code: "PLS" },
      { specialization: "Emergency Medicine", code: "EMR" },
      { specialization: "Family Physician", code: "FAM" },
      { specialization: "Rheumatologist", code: "RHE" },
      { specialization: "Infectious Disease", code: "INF" },
    ],
    "Dentist#2": [
      { specialization: "Orthodontist", code: "ORTH" },
      { specialization: "Periodontist", code: "PERI" },
      { specialization: "Endodontist", code: "ENDO" },
      { specialization: "Prosthodontist", code: "PROS" },
      { specialization: "Oral & Maxillofacial Surgeon", code: "OMS" },
      { specialization: "Pediatric Dentist", code: "PEDD" },
      { specialization: "Oral Medicine", code: "OMD" },
    ],
    "Homoeopathy#3": [
      { specialization: "General Homoeopathy", code: "HOM" },
      { specialization: "Pediatric Homoeopathy", code: "PHO" },
      { specialization: "Dermatologic Homoeopathy", code: "DHO" },
      { specialization: "Psychiatric Homoeopathy", code: "PSH" },
    ],
    "Ayurveda#4": [
      { specialization: "Panchakarma Specialist", code: "PAN" },
      { specialization: "Kayachikitsa (Internal Medicine)", code: "KAY" },
      { specialization: "Shalya Tantra (Surgery)", code: "SHY" },
      { specialization: "Shalakya Tantra (ENT & Ophthalmology)", code: "SHL" },
      { specialization: "Bala Roga (Pediatrics)", code: "BAL" },
      { specialization: "Rasashastra & Bhaishajya Kalpana", code: "RAS" },
    ],
    "Unani#5": [
      { specialization: "General Unani", code: "UNA" },
      { specialization: "Tibb-e-Akbar (Internal Medicine)", code: "TAB" },
      {
        specialization: "Ilmul Qabalat wa Amraze Niswan (Obstetrics & Gynaecology)",
        code: "IQN",
      },
    ],
    "Siddha#6": [
      { specialization: "Siddha Medicine", code: "SID" },
      { specialization: "Siddha Pulmonology", code: "SPD" },
    ],
    "Sowa-Rigpa#7": [
      { specialization: "Traditional Sowa-Rigpa", code: "SOW" },
      { specialization: "Sowa-Rigpa Internal Medicine", code: "SRM" },
    ],
    "RANM#8": [
      { specialization: "General Nursing", code: "GN" },
      { specialization: "Community Health Nurse", code: "CHN" },
    ],
    "RN#9": [
      { specialization: "Registered Nurse Specialist", code: "RNS" },
      { specialization: "Critical Care Nurse", code: "CCN" },
      { specialization: "Pediatric Nurse", code: "PEN" },
      { specialization: "Psychiatric Nurse", code: "PSN" },
    ],
    "RN & RM#10": [
      { specialization: "Midwifery Specialist", code: "MID" },
      { specialization: "Maternal & Child Health", code: "MCH" },
    ],
    "RLHV#11": [
      { specialization: "Rural Health Specialist", code: "RHS" },
      { specialization: "Primary Health Care", code: "PHC" },
    ],
  };

  const getSpecializationOptions = () => {
    if (!subCategory || subCategory.name === "Select" || !subCategory.code) {
      return [{ id: 1, name: "Select" }];
    }
    const key = `${subCategory.name}#${subCategory.code}`;
    const specs = specializations[key];
    if (!specs) return [{ id: 1, name: "Select" }];
    return [
      { id: 1, name: "Select" },
      ...specs.map((item, index) => ({
        id: index + 2,
        name: item.specialization,
        code: item.code,
      })),
    ];
  };

  // Reset subcategory when category changes
  useEffect(() => {
    if (category.name === "Select") {
      setSubCategory({ id: 1, name: "Select", code: null });
      setSpecialization({ id: 1, name: "Select" });
    } else {
      const options = getSubCategoryOptions();
      setSubCategory(options[0]);
      setSpecialization({ id: 1, name: "Select" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category.name]);

  // Reset specialization when subcategory changes
  useEffect(() => {
    if (!subCategory || subCategory.name === "Select") {
      setSpecialization({ id: 1, name: "Select" });
    } else {
      const options = getSpecializationOptions();
      setSpecialization(options[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subCategory.name, subCategory.code]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      hprId: datas?.hprId || "",
      fullName: datas?.user?.title || datas?.fullName || "",
      email: datas?.user?.email || datas?.emailId || "",
      phoneNumber: datas?.user?.phone || datas?.mobileNumber || "",
    },
  });

  // Populate form when datas changes (for view mode)
  useEffect(() => {
    if (datas && datas.id) {
      reset({
        hprId: datas?.hprId || "",
        fullName: datas?.user?.title || datas?.fullName || "",
        email: datas?.user?.email || datas?.emailId || "",
        phoneNumber: datas?.user?.phone || datas?.mobileNumber || "",
      });
      
      // Set category first
      if (datas?.category) {
        const catValue = { id: 1, name: datas.category };
        setCategory(catValue);
        
        // Set subcategory after category is set (use setTimeout to ensure category state is updated)
        setTimeout(() => {
          if (datas?.subCategory) {
            // Extract subcategory name if it's in "name#code" format
            const subCatName = datas.subCategory.includes("#")
              ? datas.subCategory.split("#")[0]
              : datas.subCategory;
            const subCatCode = datas.subCategory.includes("#")
              ? parseInt(datas.subCategory.split("#")[1])
              : null;
            
            // Get subcategory options based on the category we just set
            const tempCategory = { name: datas.category };
            const getSubCatOptions = () => {
              if (tempCategory.name === "Doctor") {
                return [
                  { id: 1, name: "Select", code: null },
                  ...hardcodedDoctorSubcategories.map((item, index) => ({
                    id: index + 2,
                    name: item.subCategory,
                    code: item.code,
                  })),
                ];
              }
              if (tempCategory.name === "Nurse") {
                return [
                  { id: 1, name: "Select", code: null },
                  ...hardcodedNurseSubcategories.map((item, index) => ({
                    id: index + 2,
                    name: item.subCategory,
                    code: item.code,
                  })),
                ];
              }
              return [{ id: 1, name: "Select", code: null }];
            };
            
            const subCatOptions = getSubCatOptions();
            const foundSubCat = subCatOptions.find(
              (sc) => sc.name === subCatName || (sc.code && sc.code === subCatCode)
            );
            if (foundSubCat) {
              setSubCategory(foundSubCat);
              
              // Set specialization after subcategory is set
              setTimeout(() => {
                if (datas?.specialization && foundSubCat.code) {
                  const specName = datas.specialization.includes("#")
                    ? datas.specialization.split("#")[0]
                    : datas.specialization;
                  const key = `${foundSubCat.name}#${foundSubCat.code}`;
                  const specs = specializations[key];
                  if (specs) {
                    const specOptions = [
                      { id: 1, name: "Select" },
                      ...specs.map((item, index) => ({
                        id: index + 2,
                        name: item.specialization,
                        code: item.code,
                      })),
                    ];
                    const foundSpec = specOptions.find(
                      (s) => s.name === specName
                    );
                    if (foundSpec) setSpecialization(foundSpec);
                  }
                }
              }, 100);
            }
          }
        }, 100);
      }
      
      if (datas?.gender) {
        const foundGender = sortsDatas.genderFilter.find(
          (g) => g.name === datas.gender
        );
        if (foundGender) setGender(foundGender);
      }
      if (datas?.title) {
        const foundTitle = titleOptions.find((t) => t.name === datas.title);
        if (foundTitle) setTitle(foundTitle);
      }
    } else {
      // Reset form for new professional
      reset({
        hprId: "",
        fullName: "",
        email: "",
        phoneNumber: "",
      });
      setTitle(titleOptions[0]);
      setGender(sortsDatas.genderFilter[0]);
      setCategory({ id: 1, name: "Select" });
      setSubCategory({ id: 1, name: "Select", code: null });
      setSpecialization({ id: 1, name: "Select" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datas, reset]);

  // Generate HPR ID (simple random generation without Aadhaar) - COMMENTED OUT
  // HPR ID is not needed without Aadhaar verification
  // const generateHprId = () => {
  //   const randomId = `HPR${Math.floor(Math.random() * 1000000)
  //     .toString()
  //     .padStart(6, "0")}`;
  //   reset({ ...control._formValues, hprId: randomId });
  //   toast.success("HPR ID generated");
  // };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const onSubmit = async (formData) => {
    // Validate Gender - must not be "Gender..."
    if (!gender || gender.name === "Gender..." || gender.id === 1) {
      toast.error("Please select a Gender");
      return;
    }

    // Validate Category - must not be "Select"
    if (!category || category.name === "Select" || category.id === 1) {
      toast.error("Please select a Category");
      return;
    }

    // Validate Sub Category - must not be "Select"
    if (!subCategory || subCategory.name === "Select" || subCategory.id === 1) {
      toast.error("Please select a Sub Category");
      return;
    }

    // Validate Specialization - must not be "Select"
    if (
      !specialization ||
      specialization.name === "Select" ||
      specialization.id === 1
    ) {
      toast.error("Please select a Specialization");
      return;
    }

    if (datas && datas.id) {
      // Update existing professional (if API supports it)
      toast.error("Update functionality not implemented yet");
      return;
    }

    // Ensure subscription agreement is checked
    if (!subscriptionAgreed) {
      toast.error("Please agree to pay the subscription fee");
      return;
    }

    // Validate phone number
    if (!formData.phoneNumber || !formData.phoneNumber.trim()) {
      toast.error("Phone number is required");
      return;
    }

    // Build payload outside try-catch so it's accessible in nested handlers
    const payload = {
      fullName: formData.fullName,
      mobileNumber: formData.phoneNumber.trim(),
      emailId: formData.email,
      // hprId: formData.hprId || undefined, // HPR ID not needed without Aadhaar verification
      gender: gender.name,
      category: category.name,
      subCategory: `${subCategory.name}#${subCategory.code}`, // Format: "name#code"
      specialization: `${specialization.name}#${specialization.code}`, // Format: "name#code"
      role: "3", // Professionals are always role 3
      inviteType: "professional", // Flag to indicate this is a professional invitation
    };

    try {
      // Get auth token
      const token = localStorage.getItem("token");

      // 1) Create Razorpay order for fixed subscription amount
      const orderResponse = await axios.post(
        `${BaseUrl}/facility/doctors/subscription/order`,
        { professional: payload },
        { 
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true 
        }
      );
      // console.log("here",orderResponse.data);

      if (!orderResponse.data?.success) {
        toast.error(
          orderResponse.data?.message ||
            "Failed to initiate subscription payment. Please try again."
        );
        return;
      }

      const { order, razorpayKeyId, amount, currency } = orderResponse.data.data;

      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        toast.error("Failed to load Razorpay. Please check your connection.");
        return;
      }

      const options = {
        key: razorpayKeyId,
        amount: order.amount,
        currency: currency || "INR",
        name: "Avijo Subscription",
        description: "Professional subscription",
        order_id: order.id,
        prefill: {
          name: payload.fullName,
          email: payload.emailId,
          contact: payload.mobileNumber,
        },
        handler: async function (response) {
          try {
            const verifyResponse = await axios.post(
              `${BaseUrl}/facility/doctors/subscription/verify`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                professional: payload,
              },
              { 
                headers: { Authorization: `Bearer ${token}` },
                withCredentials: true 
              }
            );

            if (verifyResponse.data?.success) {
              toast.success("Professional invitation sent successfully!");
              closeModal();
              window.location.reload(); // Temporary solution
            } else {
              toast.error(
                verifyResponse.data?.message ||
                  "Payment verification failed. Professional was not added."
              );
            }
          } catch (verifyError) {
            toast.error(
              verifyError.response?.data?.message ||
                "Payment verification failed. Professional was not added."
            );
          }
        },
        modal: {
          ondismiss: function () {
            toast.error("Payment cancelled. Professional was not added.");
          },
        },
        theme: {
          color: "#0095D9",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Failed to start subscription payment. Please try again."
      );
    }
  };

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={datas?.id ? "View Professional" : "Add Professionals"}
      width={"max-w-3xl"}
    >
      <form onSubmit={handleSubmit(onSubmit)} className='flex-colo gap-6'>
        {/* Search bar */}
        <div className='group mt-3 flex w-[70%] flex-row items-center justify-between self-start rounded-lg border border-border bg-dry p-3 focus-within:border focus-within:border-[#0095D9]'>
          <img
            src={require("../../Assets/images/search.png")}
            className='mr-2 h-6 w-6'
          />
          <input
            type='text'
            placeholder='Search'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className='font-md w-full bg-transparent text-sm text-black focus:outline-none'
          />
        </div>

        {/* Form fields in 2 columns */}
        <div className='grid w-full items-end gap-4 sm:grid-cols-2'>
          {/* Left Column */}
          {/* HPR ID - Commented out as Aadhaar verification is not implemented
          <div className='mt-3 w-[90%] text-sm'>
            <div className='flex w-full flex-row items-center justify-between'>
              <label className='text-sm font-bold text-black'>HPR ID</label>
              <button
                type='button'
                onClick={generateHprId}
                className='rounded-sm bg-[#0095D9] px-3 py-2 text-sm text-white hover:opacity-80'
              >
                Generate
              </button>
            </div>
            <div className='group mt-3 flex flex-row items-center justify-between rounded-lg border p-3 focus-within:border focus-within:border-[#0095D9]'>
              <Controller
                name='hprId'
                control={control}
                defaultValue=''
                render={({ field }) => (
                  <input
                    {...field}
                    type='text'
                    placeholder='Enter Health Professional ID'
                    className='w-full bg-transparent text-sm font-light focus:outline-none'
                  />
                )}
              />
              <button
                type='button'
                className='flex flex-row items-center rounded-full border border-[#0095D9] p-1 pl-4 pr-4 hover:bg-[#0095D9] hover:text-white'
              >
                <span className='mr-2 text-[#0095D9]'>Get</span>
                <img
                  src={require("../../Assets/images/restart.png")}
                  className='h-4 w-4'
                  alt='refresh'
                />
              </button>
            </div>
          </div>
          */}

          <div className='mt-3 flex w-[90%] flex-col gap-3'>
            <p className='text-sm font-bold text-black'>Title</p>
            <Select
              selectedPerson={title}
              setSelectedPerson={setTitle}
              datas={titleOptions}
            >
              <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                {title?.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>

          <FormInput
            name='fullName'
            label='Full Name *'
            placeholder='Full Name'
            control={control}
            rules={{ required: "Full name is required" }}
          />

          <FormInput
            name='email'
            label='Email'
            placeholder='Email'
            control={control}
            rules={{
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            }}
          />

          <FormInput
            name='phoneNumber'
            label='Phone Number'
            placeholder='Phone Number'
            control={control}
            rules={{ required: "Phone number is required" }}
          />

          <div className='mt-3 flex w-[90%] flex-col gap-3'>
            <p className='text-sm font-bold text-black'>Gender</p>
            <Select
              selectedPerson={gender}
              setSelectedPerson={setGender}
              datas={sortsDatas.genderFilter}
            >
              <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                {gender?.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>

          <div className='mt-3 flex w-[90%] flex-col gap-3'>
            <p className='text-sm font-bold text-black'>Category</p>
            <Select
              selectedPerson={category}
              setSelectedPerson={setCategory}
              datas={categoryOptions}
            >
              <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                {category?.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>

          <div className='mt-3 flex w-[90%] flex-col gap-3'>
            <p className='text-sm font-bold text-black'>Sub Category</p>
            <Select
              selectedPerson={subCategory}
              setSelectedPerson={setSubCategory}
              datas={getSubCategoryOptions()}
            >
              <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                {subCategory?.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>

          <div className='mt-3 flex w-[90%] flex-col gap-3'>
            <p className='text-sm font-bold text-black'>Specialization</p>
            <Select
              selectedPerson={specialization}
              setSelectedPerson={setSpecialization}
              datas={getSpecializationOptions()}
            >
              <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                {specialization?.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>
        </div>
        {/* Subscription info + agreement */}
        <div className='w-full flex flex-col items-start gap-2'>
          <p className='mt-2 w-[90%] text-xs font-medium text-black'>
            Subscription Fee: ₹500 (mandatory to add professional)
          </p>
          <div className='mt-1 w-[90%]'>
            <Checkbox
              name='subscriptionAgreement'
              checked={subscriptionAgreed}
              onChange={(e) => setSubscriptionAgreed(e.target.checked)}
              label='I agree to pay the subscription fee'
            />
          </div>
        </div>

        {/* Buttons */}
        <div className='grid w-full gap-4 sm:grid-cols-2'>
          <button
            type='button'
            onClick={closeModal}
            className='rounded-lg bg-[#B8B8B8] p-4 text-sm font-light text-white'
          >
            Cancel
          </button>
          <Button
            type='submit'
            label={datas?.id ? "Update" : "Invite"}
            Icon={HiOutlineCheckCircle}
            disabled={!subscriptionAgreed}
          />
        </div>
      </form>
    </Modal>
  );
}

// Reusable form input component using react-hook-form
const FormInput = ({ name, label, placeholder, control, rules = {} }) => {
  return (
    <div className='mt-3 w-[90%] text-sm'>
      <label className='text-sm font-bold text-black'>{label}</label>
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue=''
        render={({ field, fieldState: { error } }) => (
          <>
            <input
              {...field}
              type='text'
              placeholder={placeholder}
              className={`mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-subMain ${
                error ? "border-red-500" : ""
              }`}
            />
            {error && (
              <p className='mt-1 text-xs text-red-500'>{error.message}</p>
            )}
          </>
        )}
      />
    </div>
  );
};

export default AddDoctorModal;
